import * as utils from '@/utils';
import { SESSION_COOKIE } from '@/constants';

export const checkExistingSession = () => {
 return utils.getCookie(SESSION_COOKIE);
};

/**
 * @return {boolean} - вернет false - если передыдущая сессия коррекно завершена; вернет true - если есть незавершенная сессия (т.е. кука не стерта по завершению сессии) - и нужно очистить состояние приложения
 */
export const startSession = (sessionId) => {
  // let needRemoveSession = false;
  // let session = checkExistingSession();
  // if (session && Number(session) !== sessionId) {
  //   console.log('need remove', session, sessionId)
  //   utils.setCookie(SESSION_COOKIE, null, { expires: -1 });
  //   needRemoveSession = true;
  // }
  utils.setCookie(SESSION_COOKIE, sessionId);
  // return needRemoveSession;
};
